import { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Loading from "../../../components/Loading";
import Data from '../../../../repository';
import AppContext from "../../../../context";

import styles from '../../../../styles/Admin.module.scss';

const updateProductSchema = yup.object({
	enabled: yup.boolean(),
	description: yup.string(),
	tokenType: yup.string().oneOf(['general', 'open_gym', 'class'])
});

function UpdateProductForm() {
	const { id } = useParams();
	const navigate = useNavigate();
	const context = useContext(AppContext);
	const isHybridNew = context.domain?.businessType === 'hybrid-new';

	const [loading, setLoading] = useState(true);
	const [submitting, setSubmitting] = useState(false);
	const [serverError, setServerError] = useState(null);
	const [product, setProduct] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors },
		reset
	} = useForm({
		resolver: yupResolver(updateProductSchema),
		defaultValues: {
			enabled: true,
			description: '',
			tokenType: 'general'
		}
	});

	useEffect(() => {
		fetchProduct();
	}, []);

	const fetchProduct = async () => {
		setLoading(true);
		try {
			const result = await Data.fetchProduct(id);
			setProduct(result.data);
			reset({ enabled: result.data.enabled, description: result.data.description || '', tokenType: result.data.tokenType || 'general' });
		} catch (error) {
			setServerError('Failed to load product');
		} finally {
			setLoading(false);
		}
	}

	const onSubmit = async (data) => {
		setSubmitting(true);
		setServerError(null);

		try {
			await Data.updateProduct({
				...product,
				description: data.description?.trim() || '',
				tokenType: isHybridNew ? (data.tokenType || 'general') : 'general',
				enabled: data.enabled === 'true' || data.enabled === true
			});
			navigate("/admin/products");
		} catch (error) {
			setServerError(error.response?.data?.message || 'Failed to update product. Please try again.');
			setSubmitting(false);
		}
	}

	if (loading) return <Loading button={false} />

	return (
		<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
			<div>
				<p>Tokens:</p>
				<input type="number" value={product?.credits || 0} disabled={true} />
			</div>

			{isHybridNew ? (
				<div>
					<p>Token Type:</p>
					<select {...register('tokenType')}>
						<option value="general">General</option>
						<option value="open_gym">Open Gym</option>
						<option value="class">Class</option>
					</select>
				</div>
			) : null}

			<div>
				<p>Description:</p>
				<input
					type="text"
					{...register('description')}
					className={errors.description ? 'input-error' : ''}
				/>
				{errors.description && <span className="form-field-error">{errors.description.message}</span>}
			</div>

			<div>
				<p>Price - in pence:</p>
				<input type="number" value={product?.price || 0} disabled={true} />
			</div>

			<div>
				<p>Status:</p>
				<select {...register('enabled')}>
					<option value="true">Enabled</option>
					<option value="false">Disabled</option>
				</select>
			</div>

			{serverError && <p style={{ color: 'red' }}>{serverError}</p>}

			<button type="submit" className="btn btnPrimary" disabled={submitting}>
				{submitting ?
					<Loading button={true} />
					:
					`Save Changes`
				}
			</button>
		</form>
	)
}

export default UpdateProductForm;
